declare const gtag: any;
export const sendEvent = async (
    eventName: string,
    extra?: Record<string, string | number>,
) => {
    if (typeof gtag !== "undefined") {
        await gtag("event", eventName, extra);
    }
};
